// extracted by mini-css-extract-plugin
export default {"land_count_down":"countDown_land_count_down__KXc+Z"};